import React, {Component} from 'react';
import InvitePage from "./pages/InvitePage";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import "./styles/Fonts.css"
import "./styles/Colors.css"

import { BrowserRouter, Route, Link, Switch } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import PreviewPage from "./pages/PreviewPage";
import PlayPage from "./pages/PlayPage";


import AnnouncementPage from "./pages/AnnouncementPage";


class App extends Component {
  //  As the landing pages is static, there is no need to re-render.
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <BrowserRouter>
      <Switch>
        <Route exact-match path="/invite/:id">
          <InvitePage />
        </Route>
        {/* <Route exact-match path="/announcement">
          <AnnouncementPage />
        </Route> */}
        <Route path="/preview/:fileName/:token">
          <PreviewPage />
        </Route>
        <Route path="/play/:name">
          <PlayPage />
        </Route>        
        <Route path="/message">
          <PreviewPage />
        </Route>                
        <Route path="/privacy">
          <PrivacyPolicy />
        </Route>
        <Route path="/tos">
          <TermsOfService />
        </Route>
        <Route path="/">
          <LandingPage />
        </Route>
      </Switch>
    </BrowserRouter>      
    );

  }
}

export default App;
